module.exports = __webpack_public_path__ + "static/media/ringtone.0be3c651.mp3";